var React = require('react');

function LegendPartnerStatesStories (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"map legend icon for partner states"),React.createElement("rect",{"fill":"#E11D38","x":"0","y":"0","width":"27","height":"16","key":1}),React.createElement("rect",{"stroke":"#A71E22","strokeWidth":"2","fill":"#FFFFFF","transform":"rotate(-45) translate(-9, -17)","x":"10","y":"30","width":"6.13603897","height":"6.13603897","key":2})]);
}

LegendPartnerStatesStories.defaultProps = {"width":"27px","height":"16px","viewBox":"0 0 27 16"};

module.exports = LegendPartnerStatesStories;

LegendPartnerStatesStories.default = LegendPartnerStatesStories;



//////////////////
// WEBPACK FOOTER
// ./src/static/svgs/legend-partner-states-stories.svg
// module id = 936
// module chunks = 35783957827783